<script>
  import { CascaderPanel } from 'element-ui'
  export default {
    name:'ElCascaderPanel',
    extends:CascaderPanel
  }
</script>
